// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d4271159","455":"828ab949","977":"28aedc2c"}[chunkId] + ".chunk.js";
};